module.exports = __webpack_public_path__ + "static/media/box.df8b84d5.png";